module.exports = __webpack_public_path__ + "static/media/icon-points.181dc826.svg";